import { store } from "../store";
export const getProgressDataFromStatusUrl = async (statusUrl) => {
    const response = await fetch(statusUrl);
    const jobStatusData = await response.json();
    const progressUrl = jobStatusData.progressUrl;
    const hlsJobStatus = await fetch(progressUrl);
    const hlsData = await hlsJobStatus.json();
    return { ...hlsData, progressUrl };
};
export const isProjectProcessingVideos = async () => {
    const videoStatusDict = store.getState().contentReducer.contentDoc.videoStatusDict ?? {};
    let processingVideos = false;
    for (const key in videoStatusDict) {
        const { status, progressUrl } = videoStatusDict[key];
        if (status === "pending" || status === "ready") {
            const hlsJobStatus = await fetch(progressUrl);
            const hlsJobStatusData = await hlsJobStatus.json();
            processingVideos = hlsJobStatusData.status === "pending" || hlsJobStatusData.status === "ready";
        }
    }
    return processingVideos;
};
